export default "__VITE_ASSET__DQ$L51$H__"